<template>
  <div :class="['ep-error', {'visible': errorIsVisible}, {'ep-error__middle': centered}, {'ep-error__fullWidth': fullWidth}]">
      {{ errorMessage }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {

  name: 'snackbar',

  computed: mapGetters({
    errorIsVisible: 'application/errorIsVisible',
    errorMessage: 'application/errorMessage',
    centered: 'application/snackbarCentered',
    fullWidth: 'application/fullWidth',
  }),
};
</script>



// WEBPACK FOOTER //
// src/components/snackbar.vue